import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { t } from "i18next";

const CommentInteraction = ({
  isOwnedPost,
  item,
  AllPostList,
  handleEdit,
  setPostList,
  postList,
  postId
}) => {
  console.log('isOwnedPost',  postList);

  const sessionId = localStorage.getItem("sessionId");
  const dropdownRef = useRef(null);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Delete Post start
  const [show, setShow] = useState(false);
  const handleDeleteClose = () => {
    setShow(false);
  };
  // console.log("postList999999900000000===>111",postList);
  
  const deleteComment = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: item.pstCmntId,
      langKey: language === "en" ? "" : language,

    };
    const scrollY = window.scrollY;

    try {
      await axios.post(`PostAction/DeleteComment`, responseData).then((res) => {      
        const updatedPostList = postList.map((post) => {
          if (post?.postInfo?.postId === postId) {
            const updatedComments = post?.postInfo?.comments.filter(
              (comment) => comment?.pstCmntId !==  item.pstCmntId
            );

            return {
              ...post, 
              postInfo: {
                ...post.postInfo,
                comments: updatedComments,
                commentCount:( post.postInfo.commentCount || 1) - 1,
              }
            };
          }
          return post;
        });
        setShow(false);
        setToastMessage(res.data.message);
        setShowToast(true);
        setPostList(updatedPostList);
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  // Delete Post End

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(null);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.body.style.position = 'fixed';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.body.style.position = '';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);

  // useEffect(() => {
  //   if (show) {
  //     // const scrollY = window.scrollY;
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = '0';
  //     document.body.style.right = '0';
  //     document.body.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open');
  //   } else {
  //     const scrollY = document.body.style.top;
  //     document.body.style.position = '';
  //     document.body.style.top = '';
  //     document.body.style.left = '';
  //     document.body.style.right = '';
  //     document.body.style.overflow = '';
  //     document.body.classList.remove('modal-open');
  
  //     // Restore scroll position
  //     window.scrollTo(0, parseInt(scrollY || '0') * -1);
  //   }
  // }, [show]);
  

  return (
    <>
      {(item?.isOwned || isOwnedPost) && (
        <div
          className="postMenu pointer commentInteraction"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />

          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal"
            >
              {(item?.isOwned || isOwnedPost) && (
                <Dropdown.Item as="button" className="dropdownList">
                  <Link
                    onClick={() => {
                      setShow(!show);
                      toggleDropdown();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14">{t("Drafts.Delete")} </span>
                    </div>
                    <p className="f-12 dropdownPara"> 
                      {t("Drafts.Once Deleted it can't be recovered")}
                    </p>
                  </Link>
                </Dropdown.Item>
              )}
              {item?.isOwned && (
                <Dropdown.Item as="button" className="dropdownList">
                  <Link
                    onClick={() => {
                      handleEdit();
                      // setEditedComment(item.comment);
                      // setpstCmntId(item.pstCmntId);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <EditSharpIcon className="material-symbols-sharp me-2" />

                      <span className="dropdownTxt f-14">{t("Drafts.Edit")}</span>
                    </div>
                    <p className="f-12 dropdownPara">{t("Drafts.Edit Comment")}</p>
                  </Link>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          )}
        </div>
      )}



      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deleteComment()}
                >
                  {t("Drafts.Delete")}
                </button>
                
              </div>

            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentInteraction;
